// @flow strict
import React from 'react';
import {Helmet} from 'react-helmet';
import { withPrefix } from 'gatsby';
import type { Node as ReactNode } from 'react';
import { useSiteMetadata } from '../../hooks';
import stylesOriginal from './Layout.module.scss';
import stylesPost from './Layout_post.module.scss';

type Props = {
  children: ReactNode,
  title: string,
  description?: string,
  socialImage? :string
};

const Layout = ({
  children,
  title,
  description,
  socialImage
}: Props) => {
  const { author, url } = useSiteMetadata();
  const metaImage = socialImage != null ? socialImage : author.photo;
  const metaImageUrl = url + withPrefix(metaImage);

  const layoutStyle = description !== null && description !== '' ? stylesOriginal.layout : stylesPost.layout;

  return (
    <div className={layoutStyle}>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content={description} />
        <meta property="og:site_name" content={title} />
        <meta property="og:image" content={metaImageUrl} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={metaImageUrl} />
        <meta name="google-site-verification" content="-6EETOPRh4viSvax9fJYLpXE6C5NHVJ_gra9xlPX9zc" />
      </Helmet>
      <noscript>
        Smoke-indica.com requires javascript to run properly.
        Check out <a href="https://smoke.io">Smoke.io</a> if your browser doesn't support javascript.
      </noscript>
      {children}
    </div>
  );
};

export default Layout;
